export const sortCategoryLevels = (lvl0: string[] = [], mainCategories: string[] = []): string[] => {
  const lvl0Lower = lvl0?.map((item) => item?.toLowerCase());
  const hasMain = mainCategories?.some((cat) => lvl0Lower?.includes(cat?.toLowerCase()));
  const hasBrand = lvl0Lower?.includes('brands');

  if (hasMain) {
    // Main categories first, then the rest excluding 'brands'
    return [
      ...mainCategories?.filter((cat) => lvl0Lower?.includes(cat?.toLowerCase())),
      ...lvl0?.filter(
        (item) =>
          !mainCategories?.map((m) => m?.toLowerCase())?.includes(item?.toLowerCase()) &&
          item?.toLowerCase() !== 'brands',
      ),
    ];
  } else if (hasBrand) {
    // Only 'brands'
    return lvl0?.filter((item) => item?.toLowerCase() === 'brands');
  } else {
    // Sort alphabetically
    return [...lvl0]?.sort((a, b) => a?.localeCompare(b));
  }
};
